import i18n from './index';

/**
 * Text built by plain helpers (utils, not components) in the nursery module:
 * `locales/<lng>/nursery/shared.json`. A component that shows one re-renders
 * on a language change through its own useTranslation, so the helper reads the
 * language at call time and needs no hook.
 *
 * Keys here are not checked against the source by catalogue.test.ts (it reads
 * components); the helpers' own unit tests pin the English.
 */
export function nurseryText(key: string, values?: Record<string, unknown>): string {
  return i18n.t(`nursery:shared.${key}`, values ?? {}) as string;
}
